import React from 'react';
import projects from '../Data/projects';
import ProjectList from '../Components/ProjectList';

const Projects = () => {
    return (
        <React.Fragment>
            <ProjectList />
        </React.Fragment>
    )
}

export default Projects;
